module.exports = __webpack_public_path__ + "static/media/flogo-HexRBG-Wht-72.9700c594.svg";